import React from 'react';
import { Row, Col } from 'tea-component';
import KeyMetricItem from './KeyMetricItem';

interface IMetricsList {
  gameInfo: any;
  filter: any;
}
export default function MetricsList(props: IMetricsList) {
  return (
    <Row className="dbo-voice-keyMetric-card">
      <Col span={12}>
        <KeyMetricItem
          statsType={'reports'}
          title={'Total Report'}
          {...props}
        ></KeyMetricItem>
      </Col>
      <Col span={12}>
        <KeyMetricItem
          statsType={'reported_players'}
          title={'Number of Reported Players'}
          {...props}
        ></KeyMetricItem>
      </Col>
    </Row>
  );
}
